<template>
  <div class="container z-grid v-page-section-container-padding">
    <div class="z-grid__cols">
      <MoleculeVideo :video-code="videoCode" :subtitle="subtitle" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  videoCode: { type: String, required: true },
  subtitle: { type: String, required: false, default: undefined },
})
</script>
